import React from 'react';
import { Text, Modal, Button } from 'quanta-ui';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ModalSubmitQuote({
  submitQuoteModalDisplay,
  onClose,
  onSubmitQuote,
}) {
  return (
    <Modal
      size="small"
      display={submitQuoteModalDisplay}
      severity="warning"
      title={
        <Text
          className="flex space-x-3 items-end justify-start w-full"
          type="title"
          severity="warning"
        >
          <Text>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size={'lg'}
            />
          </Text>
          <Text type="title">{'Confirm Submit'}</Text>
        </Text>
      }
      onClose={(_) => {
        onClose();
      }}
    >
      <Text className="flex flex-row space-x-2 justify-start w-full">
        <Text className="flex flex-col space-y-4 justify-start w-full">
          <Text type="normal">
            {'Are you sure you want to submit the quote?'}
          </Text>
          <Text className={'flex space-x-2'}>
            <Text type={'label'} severity={'warning'}>
              Note:
            </Text>
            <Text type={'label'}>
              Clicking on OK, we will be linking the quote with customer and you won't be able to change any information for this quote further.
            </Text>
          </Text>
          <Text className="flex justify-end w-full space-x-4">
            <Text>
              <Button
                size="small"
                type={'button'}
                flat={false}
                className="w-20"
                onClick={(_) => {
                  if (onSubmitQuote) {
                    onSubmitQuote();
                  }
                  onClose();
                }}
              >
                OK
              </Button>
            </Text>
            <Text>
              <Button
                size="small"
                type={'button'}
                flat
                className="w-20"
                onClick={(_) => {
                  onClose();
                }}
              >
                Cancel
              </Button>
            </Text>
          </Text>
        </Text>
      </Text>
    </Modal>
  );
}
